import { render } from "./VacantOrders.vue?vue&type=template&id=116d20b4&lang=pug"
import script from "./VacantOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./VacantOrders.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__